import React, { useState } from "react";
import {
  paymentMethodTitles,
  PAYMENT_BANK_SLIP,
  PAYMENT_ITAU_BANK_SLIP,
  PAYMENT_CREDIT_CARD_RECURRENT
} from "constants/sales";
import { semanticDate } from "global/functions";
import { Grid, Button, Typography, IconButton, Collapse, List, ListItem, ListItemText, Divider } from "@material-ui/core";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import { convertCurrency, decimalCharFromEn } from "helpers";

const PaymentRowShow = ({ row, form, installments }) => {
  const [open, setOpen] = useState(false);
  const hasInstallments = row.months > 1;

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={5}>
          <Typography variant="subtitle2" color="textSecondary">
            <strong>Valor</strong>
          </Typography>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1">
              {(row.payment_method === PAYMENT_BANK_SLIP ||
                row.payment_method === PAYMENT_ITAU_BANK_SLIP ||
                row.payment_method === PAYMENT_CREDIT_CARD_RECURRENT) ? (
                `${convertCurrency(row.value * row.months)}${row.months && row.months > 1
                  ? ` em ${row.months} vezes de ${convertCurrency(row.value)}`
                  : ""}`
              ) : (
                <>
                  {`${convertCurrency(row.value)}${row.months && row.months > 1
                    ? ` em ${row.months} vezes de ${convertCurrency(row.value / row.months)}`
                    : ""}`}
                  {row.interest_percentage ? (
                    <Typography color="textSecondary" component="span" variant="caption" style={{ marginLeft: 4 }}>
                      {` (juros de ${decimalCharFromEn(row.interest_percentage)}%)`}
                    </Typography>
                  ) : null}
                </>
              )}
            </Typography>

            {hasInstallments && (
              <IconButton
                size="small"
                onClick={() => setOpen(!open)}
                style={{ marginLeft: 4 }}
              >
                {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
              </IconButton>
            )}
          </div>
          {row.name && (
            <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
              Responsável: {`${row.name} ${row.doc_number ? `- ${row.doc_number}` : ''}`}
            </Typography>
          )}
        </Grid>

        <Grid item xs={2}>
          <Typography variant="subtitle2" color="textSecondary">
            <strong>Forma de pagamento</strong>
          </Typography>
          <Typography variant="body1">{paymentMethodTitles[row.payment_method]}</Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography variant="subtitle2" color="textSecondary">
            <strong>
              {`${row.payment_method === PAYMENT_BANK_SLIP ? "Primeira data" : "Data"} de vencimento`}
            </strong>
          </Typography>
          <Typography variant="body1">{semanticDate(row.due_date)}</Typography>
        </Grid>

        <Grid item xs={2} style={{ textAlign: "right" }}>
          <Button type="submit" variant="contained" color="secondary" size="small">
            Remover
          </Button>
        </Grid>
      </Grid>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <div style={{
          marginTop: 12,
          padding: '8px 16px',
          backgroundColor: '#f5f5f5',
          borderRadius: 4,
          border: '1px solid #e0e0e0'
        }}>
          <Typography variant="caption" color="textSecondary" gutterBottom style={{ display: 'block', fontWeight: 'bold' }}>
            DETALHAMENTO DAS PARCELAS
          </Typography>
          <List dense>
            {installments && installments
              .sort((a, b) => a.month_number - b.month_number)
              .map((inst, idx) => (
                <React.Fragment key={inst.id || idx}>
                  <ListItem disableGutters>
                    <ListItemText
                      primary={`Parcela ${inst.month_number}/${inst.months}`}
                      secondary={`Vencimento: ${semanticDate(inst.due_date)}`}
                    />
                    <Typography variant="body2" style={{ fontWeight: 600 }}>
                      {convertCurrency(inst.value)}
                    </Typography>
                  </ListItem>
                  {idx < installments.length - 1 && <Divider />}
                </React.Fragment>
              ))}
          </List>
        </div>
      </Collapse>
    </>
  );
};

export default PaymentRowShow;
